import React, { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { UserRolesEnum } from '@families-link/shared';
import { useGetUserDistrictByIdQuery } from '../../../../store/api/users.api';
import { setLocalStorageDistrictId } from '../../utils';
import { DistrictRoutes } from '../../../district/constants';
import { useCurrentAccessTokenSelector } from '../../../auth';
import { ProfileRoutes } from '../../../profile/constants';
import { skipToken } from '@reduxjs/toolkit/query';
import { useSessionStorage } from '../../../../hooks';

export const DistributionPage: FC = () => {
	const currentToken = useCurrentAccessTokenSelector();
	const { data: userDistrictId } = useGetUserDistrictByIdQuery(currentToken?.payload.sub ?? skipToken);
	const [sessionStorageDistrictId, setSessionStorageDistrictId] = useSessionStorage('districtId');

	if (userDistrictId) {
		setLocalStorageDistrictId(userDistrictId);
		setSessionStorageDistrictId(userDistrictId);
		return <Navigate to={DistrictRoutes.Dashboard} />;
	}

	if (UserRolesEnum.SuperAdmin === currentToken?.payload.sur) {
		return <Navigate to={ProfileRoutes.Root} />;
	}

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				paddingTop: '15%',
			}}
		>
			LOADING...
		</Box>
	);
};
